import type { ReactNode, MouseEvent, FC } from 'react';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiEvent } from '@wix/da-bi/pkg/events';

import s from './BasicBlankSlate.scss';

interface Props {
  title: string;
  message: string;
  illustrationSrc?: string;
  cta?: ReactNode;
  ctaLabel?: string;
  ctaHref?: string;
  ctaOnClick?: (ev: MouseEvent) => void;
  ctaBiData?: BiEvent;
  tabsSlot?: ReactNode;
}

const ILLUSTRATION_HEIGHT = 120;

const BasicBlankSlate: FC<Props> = ({
  title,
  message,
  illustrationSrc,
  cta,
  ctaLabel,
  ctaHref,
  ctaOnClick,
  ctaBiData,
  tabsSlot,
}) => {
  const withCta = Boolean(cta || ctaLabel);
  return (
    <>
      {tabsSlot}
      <div className={s['root']}>
        <div className={s['content']}>
          {illustrationSrc && (
            <img
              className={s['illustration']}
              alt=""
              src={illustrationSrc}
              height={ILLUSTRATION_HEIGHT}
            />
          )}
          <div className={s['title']}>{title}</div>
          <div className={s['message']}>{message}</div>
          {withCta
            ? cta || (
                <BrandedButton
                  variant="brand-green"
                  size="large"
                  href={ctaHref}
                  onClick={ctaOnClick}
                  biData={ctaBiData}
                >
                  {ctaLabel}
                </BrandedButton>
              )
            : null}
        </div>
      </div>
    </>
  );
};
BasicBlankSlate.displayName = 'BasicBlankSlate';

export default BasicBlankSlate;
